import { render, staticRenderFns } from "./BindCrypto.vue?vue&type=template&id=0ff89aa7&scoped=true"
import script from "./BindCrypto.vue?vue&type=script&lang=js"
export * from "./BindCrypto.vue?vue&type=script&lang=js"
import style0 from "./BindCrypto.vue?vue&type=style&index=0&id=0ff89aa7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff89aa7",
  null
  
)

export default component.exports